import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Modal } from "react-bootstrap";
import Util from "../../../../util/Util";
import {
  checkIfUsernameExistsByGroupId,
  createUser,
  updateUser,
} from "../../../../actions/user/user";
import Roles from "../../../../enums/Roles";

class GroupsUserAddModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: null,
      first_name: null,
      name: null,
      email: null,
      password: null,

      usernameError: null,
      first_nameError: null,
      nameError: null,
      emailError: null,
      passwordError: null,
      hasWritePermission: false,
    };
    if (this.props.user !== undefined) {
      this.state = {
        username: this.props.user.username,
        name: this.props.user.name,
        first_name: this.props.user.first_name,
        email: this.props.user.email,
        group_id: this.props.group._id,
        password: "*********",
        hasWritePermission: this.props.user.has_write_permission,
      };
    }
  }

  lookForChange() {
    if (
      this.state.name === this.props.user.name &&
      this.state.first_name === this.props.user.first_name &&
      this.state.username === this.props.user.username &&
      this.state.email === this.props.user.email &&
      this.state.password === "*********" &&
      this.state.hasWritePermission ===
        this.props.user.has_write_permission
    ) {
      return false;
    } else {
      return true;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    // No previous error
    if (this.hasError()) return;

    if (this.props.user === undefined) {
      var data = {
        user: {
          username: this.state.username,
          name: this.state.name,
          first_name: this.state.first_name,
          email: this.state.email,
          role: Roles.SUPERVISOR,
          company_id: null,
          group_id: this.props.group._id,
          password: this.state.password,
          has_write_permission: this.state.hasWritePermission,
        },
      };

      // Send login information and redirect on success
      this.props.onCreateUser(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    } else {
      data = {
        user: {
          _id: this.props.user._id,
          username: this.state.username,
          name: this.state.name,
          first_name: this.state.first_name,
          email: this.state.email,
          role: Roles.SUPERVISOR,
          company_id: null,
          group_id: this.props.group._id,
          password:
            this.state.password !== "*********" ? this.state.password : null,
          has_write_permission: this.state.hasWritePermission,
        },
      };

      this.lookForChange() &&
        this.props.onUpdateUser(
          data,
          () => this.props.close(),
          (e) => console.log(e),
        );
    }
  }

  hasEmptyField() {
    return (
      !this.state.username ||
      !this.state.first_name ||
      !this.state.name ||
      !this.state.email ||
      !this.state.password
    );
  }

  hasError() {
    return (
      this.state.usernameError ||
      this.state.first_nameError ||
      this.state.nameError ||
      this.state.emailError ||
      this.state.passwordError
    );
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    // Check if username is not empty and not already taken
    if (field === "username" && !Util.emptyString(value)) {
      this.setState({ usernameError: null });
      this.props.onCheckIfUsernameExistsByGroupId(
        value,
        this.props.group._id,
        () => {
          this.setState({
            usernameError: <FormattedMessage id="Username.Already.Exists" />,
          });
        },
        () => this.setState({ usernameError: null }),
      );
    }
  }

  update(field) {
    if (this.disabled() || !this.isUpdate()) return;

    if (
      this.isUpdate() &&
      field === "email" &&
      this.props.collaborator.email === this.state[field]
    )
      return;

    if (
      this.isUpdate() &&
      field === "username" &&
      this.props.collaborator.username === this.state[field]
    )
      return;

    this.props.onUpdateCollaborator({
      collaboratorId: this.props.collaborator._id,
      updatedField: field,
      updatedValue: this.state[field],
    });
  }

  render() {
    return (
      <Modal
        show={true}
        size="lg"
        onHide={() => this.props.close()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.user === undefined ? (
              <FormattedMessage id="Add.User" />
            ) : (
              <FormattedMessage id="Edit.User" />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
            <div className="form-group">
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="group" className="col-form-label">
                    <FormattedMessage id="Group" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="group"
                    name="group"
                    className="form-control"
                    value={this.props.group.name}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="first_name" className="col-form-label">
                    <FormattedMessage id="First.Name" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                      id: "First.Name",
                    })}
                    defaultValue={this.state.first_name}
                    onChange={(e) =>
                      this.onChange("first_name", e.target.value)
                    }
                  />
                  <small className="text-danger">
                    {this.state.first_nameError}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <div className="col">
                  <label htmlFor="name" className="col-form-label">
                    <FormattedMessage id="Name" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                      id: "Name",
                    })}
                    defaultValue={this.state.name}
                    onChange={(e) => this.onChange("name", e.target.value)}
                  />
                  <small className="text-danger">{this.state.nameError}</small>
                </div>
              </div>

              <div className="form-group row">
                <div className="col">
                  <label htmlFor="username" className="col-form-label">
                    <FormattedMessage id="Username" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="username"
                    name="username"
                    className="form-control"
                    autoComplete="off"
                    placeholder={this.props.intl.formatMessage({
                      id: "Username",
                    })}
                    defaultValue={this.state.username}
                    onChange={(e) => this.onChange("username", e.target.value)}
                  />
                  <small className="text-danger">
                    {this.state.usernameError}
                  </small>
                </div>
              </div>

              <div className="form-group row">
                <div className="col">
                  <label htmlFor="email" className="col-form-label">
                    <FormattedMessage id="Email" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    autoComplete="off"
                    placeholder={this.props.intl.formatMessage({
                      id: "Email",
                    })}
                    defaultValue={this.state.email}
                    onChange={(e) => this.onChange("email", e.target.value)}
                  />
                  <small className="text-danger">{this.state.emailError}</small>
                </div>
              </div>

              <div className="form-group row mb-5">
                <div className="col">
                  <label htmlFor="password" className="col-form-label">
                    <FormattedMessage id="Password" />
                  </label>
                </div>
                <div className="col-7">
                  <input
                    type="password"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                      id: "Password",
                    })}
                    defaultValue={this.state.password}
                    autoComplete="off"
                    onChange={(e) => this.onChange("password", e.target.value)}
                  />
                  <small className="text-danger">
                    {this.state.passwordError}
                  </small>
                </div>
              </div>
            </div>

            <div className="form-group row mb-5">
              <div className="col">
                <label htmlFor="password" className="col-form-label">
                  <FormattedMessage id="Can.Manage.Pharmacies.From.Group" />
                </label>
              </div>
              <div className="form-check col-7 align-content-center text-left">
                <input
                  type="checkbox"
                  id="hasWritePermission"
                  checked={this.state.hasWritePermission}
                  onChange={(e) =>
                    this.onChange(
                      "hasWritePermission",
                      !this.state.hasWritePermission,
                    )
                  }
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-4 m-auto">
                <button
                  type="submit"
                  disabled={
                    this.props.user === undefined
                      ? this.hasEmptyField()
                      : !this.lookForChange()
                  }
                  className="btn btn-info btn-block button-info right"
                >
                  {this.props.user === undefined ? (
                    <FormattedMessage id="Create" />
                  ) : (
                    <FormattedMessage id="Update" />
                  )}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfUsernameExistsByGroupId: (
      username,
      groupId,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        checkIfUsernameExistsByGroupId(
          username,
          groupId,
          existsCallback,
          noExistsCallback,
        ),
      ),
    onCreateUser: (data, successCallback, failureCallback) =>
      dispatch(createUser(data, successCallback, failureCallback)),
    onUpdateUser: (data, successCallback, failureCallback) =>
      dispatch(updateUser(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupsUserAddModal));
